
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
    

import { useEffect, useState } from 'react';
import { projectObjects } from './ProjectObject';
export function Projects() {
    const [activeTag, setActiveTag] = useState("");

    const tags = ["React", "Redux", "JavaScript", "Squarespace", "API", "HTML/CSS", "MongoDB", "Express", "X"];

    const badge = (tag, i) => {
        if (tag === "X" ) {
            return (
                <Badge key={tag+i} className='m-1' bg="danger" onClick={() => handleSortClick(tag)}>
                 {tag}
                </Badge>
            )
        }
        else if (activeTag === tag || !activeTag || activeTag === "X" ) {
            return (
                <Badge key={tag+i} className='m-1' bg="info" onClick={() => handleSortClick(tag)}>
                {tag}
               </Badge>
            )
        }
        else {
            return (
                <Badge className='m-1' bg="secondary" onClick={() => handleSortClick(tag)}>
                    {tag}
                </Badge>
            )
        }

    }
    const handleSortClick = (str) => {
        setActiveTag(str);
        console.log(str)
    }
    const cardObject = (project, i) => {
        if (project.tags.includes(activeTag) || !activeTag || activeTag === "X")
            return (
                <Col key={project.title + i}>
                    <Card className='shadow' bg={"dark"} text='white' >
                        <Card.Body>
                            <Card.Img src={project.img} variant="top" />
                            <Card.Title className='hero-card-title'>{project.title}</Card.Title>
                            {project.tags.map((tag) => {
                                return (
                                    <Badge className='m-1' bg="info">
                                        {tag}
                                    </Badge>
                                )
                            })}
                            <Card.Text>
                                {project.text}
                            </Card.Text>
                            <Button href={project.href} variant="outline-light">Check it out!</Button>
                        </Card.Body>
                    </Card>
                </Col>
            )
    }

    const mapProjectsOne = [...projectObjects].slice(0, 3).map((project, i) => {
        return cardObject(project, i);

    });

    const mapProjectsTwo = [...projectObjects].slice(3, 6).map((project, i) => {
        return cardObject(project, i);

    });






    useEffect(() => { }, [activeTag])
    return (
        <Container className='mt-5 projects-section' id="projects">
            <h2 className='text-white'>My Recent Projects</h2>
            <div className='tag-sort'>
              {tags.map((tag, i) => badge(tag,i))}
            </div>
            <Row className='m-3'>
                {mapProjectsOne}

                {mapProjectsTwo}

            </Row>
        </Container>
    );
}